// extracted by mini-css-extract-plugin
module.exports = {"skillsHeader":"SkillsHeader_skills-header__ts-sV","name":"SkillsHeader_name__cJcOO","badgeContainer":"SkillsHeader_badge-container__1Twmc","badge":"SkillsHeader_badge__10S86"};